export default function (param) {

}